var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.prospect)?_c('div',{class:[
    'circle',
    { completed: _vm.campaign.order <= _vm.prospect.status || _vm.prospect.is_converted } ]},[(_vm.isConverted && !_vm.campaignNum)?_c('img',{attrs:{"src":require("@assets/images/emoji-congrats.svg")}}):_c('span',[_vm._v(_vm._s(_vm.campaignNum))])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }